<template>
  <footer>
    <cookie-law theme="heraklith" v-on:accept="initGTM" buttonText="Akzeptieren" v-if="$store.state.iframeMode === false">
      <div slot="message">
        Um Ihnen einen optimalen Service zu bieten, verwendet diese Website Cookies.
        Durch die Nutzung unserer Seite erklären Sie sich damit einverstanden.
        Mehr Informationen in unserer <a href="https://www.heraklith.de/datenschutz" target="_blank" rel="noopener noreferer">Datenschutzerklärung</a>.
      </div>
    </cookie-law>
  </footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law';

export default {
  components: { CookieLaw },
  mounted() {
    const accepted = window.localStorage.getItem('cookie:accepted');
    if (accepted !== null && JSON.parse(accepted) === true) {
      this.initGTM();
    }
  },
  methods: {
    initGTM() {
      const script = document.createElement('script');
      script.async = true;
      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          // eslint-disable-next-line prefer-rest-params
          window.dataLayer.push(arguments);
        }

        gtag('js', new Date());
      };
      script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-29002090-5';
      document.head.appendChild(script);
    },
  },
};
</script>

<style lang="scss">
.Cookie--heraklith {
  background: #424851;
  color: $color-white;
  padding: 1.250em;

  .Cookie__button {
    margin-bottom: 12px;
    padding: 13px 15px 9px;
    display: block;
    font-family: $font-bold;
    text-align: center;
    text-decoration: none;
    border: 1px solid transparent;
    background-color: $color-primary;
    color: $color-black;

    &:hover {
      background-color: $color-primary;
      color: $color-black;
    }
  }
}
</style>
